import { Globe, Clock, Gauge } from "lucide-react";
import { fmtDateTime } from "@/lib/constants";

/** Provenance pill — every AI output shows source, scrape date and confidence. */
export function ProvenancePill({ provenance, aiGenerated }) {
  if (!provenance) return null;
  return (
    <div className="flex flex-wrap items-center gap-2 text-xs" data-testid="provenance-pill">
      <span className="inline-flex items-center gap-1.5 rounded-full border border-border bg-muted/50 px-2.5 py-1 text-muted-foreground">
        <Globe className="h-3 w-3" />
        {provenance.source_url ? (
          <a href={provenance.source_url} target="_blank" rel="noreferrer" className="hover:text-primary truncate max-w-[220px]">
            {provenance.source || provenance.source_url}
          </a>
        ) : (provenance.source || "unknown source")}
      </span>
      <span className="inline-flex items-center gap-1.5 rounded-full border border-border bg-muted/50 px-2.5 py-1 text-muted-foreground">
        <Clock className="h-3 w-3" /> {fmtDateTime(provenance.scraped_at)}
      </span>
      {provenance.confidence != null && (
        <span className="inline-flex items-center gap-1.5 rounded-full border border-border bg-muted/50 px-2.5 py-1 text-muted-foreground">
          <Gauge className="h-3 w-3" /> {provenance.confidence}% confidence
        </span>
      )}
      <span className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 border ${aiGenerated ? "border-primary/40 bg-primary/10 text-primary" : "border-amber-500/30 bg-amber-500/10 text-amber-400"}`}>
        {aiGenerated ? "AI-drafted" : "Template fallback"}
      </span>
    </div>
  );
}
